<template>
  <div class="merchants-form-compontents">
    <el-form label-position="top" ref="merchantsForm" :model="merchantsForm" :disabled="isSubmiting">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="* 类型" prop="typeId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.typeId"
              placeholder="请选择类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in merchantTypesOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="* 姓名" prop="name">
            <el-input
              v-model="merchantsForm.name"
              style="width: 100%"
              placeholder="请填写姓名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="* 手机" prop="telephoneNo">
            <el-input
              v-model="merchantsForm.telephoneNo"
              style="width: 100%"
              @blur="onPhoneBlur"
              placeholder="请填写手机"
            ></el-input>
            <span
              class="el-form-item__error"
              style="text-align: right"
              v-if="isPhoneRepeat"
              clearable
              >该手机号已存在</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="* 城市">
            <el-cascader
              v-model="cityValue"
              :options="cityOptions"
              @change="handleCityChange"
              style="width: 100%"
              clearable
              filterable
              placeholder="请选择城市"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              v-model="merchantsForm.companyName"
              style="width: 100%"
              placeholder="请填写公司名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label=" this.merchantsForm.selfDevelop ? '* 目前经营品牌' : '目前经营品牌'" prop="brandId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.brandId"
              placeholder="请选择目前经营品牌"
              clearable
              filterable
            >
              <el-option
                v-for="item in brandOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <!-- <el-input v-model="merchantsForm.brandName" style="width: 100%" placeholder="请填写目前经营品牌" clearable></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司类型" prop="companyTypeId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.companyTypeId"
              placeholder="请选择公司类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in companyOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="跟进状态" prop="followUpStatusId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.followUpStatusId"
              placeholder="请选择跟进状态"
              clearable
              filterable
            >
              <el-option
                v-for="item in followUpStatusOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="跟进人" prop="ownerId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.ownerId"
              placeholder="请选择跟进人"
              clearable
              filterable
            >
              <el-option
                v-for="item in ownersOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="途径" prop="sourceId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.sourceId"
              placeholder="请选择途径"
              clearable
              filterable
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索" prop="promotionCompanyId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.promotionCompanyId"
              placeholder="请选择线索"
              filterable
              clearable
            >
              <el-option
                v-for="item in promotionCompanyOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="阶段" prop="stageId">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.stageId"
              placeholder="请选择阶段"
              filterable
              clearable
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索分类" prop="selfDevelop">
            <el-select
              style="width: 100%"
              v-model="merchantsForm.selfDevelop"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option label="自主开发" :value="true"></el-option>
              <el-option label="公司资源" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center; margin-top: 40px">
        <el-button type="primary" @click="onSubmit('merchantsForm')" :loading="isSubmiting"
          >{{isSubmiting ? '正在提交...' : '提  交'}}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cities from "@/api/areaData/cities.json";
import states from "@/api/areaData/states.json";
import { isEmprty, isPhone } from "@/utils/validate";
import formSelection from "../mixins/formSelection.js";
export default {
  name: "merchantsForm",
  mixins: [formSelection],
  props: {
    isSelfDevelop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmiting: false,
      merchantsForm: {
        brandName: "",
        city: "",
        companyName: "",
        country: "中国",
        name: "",
        province: "",
        sourceId: 3,
        telephoneNo: "",
        typeId: 10,
        promotionCompanyId: 1,
        companyTypeId: null,
        followUpStatusId: null,
        ownerId: null,
        stageId: null,
        brandId: null,
        selfDevelop: false,
      },
      cityValue: [],
      cityOptions: [],
      isPhoneRepeat: false,
    };
  },
  created() {
    this.merchantsForm.selfDevelop = this.isSelfDevelop
    this.formatAreaData();
  },

  methods: {
    formatAreaData() {
      let provinceData = states["RECORDS"].filter(
        (ele) => ele.country_id == 44
      );
      let tempOptionsData = [];
      provinceData.forEach((ele) => {
        tempOptionsData.push({
          value: ele.cname,
          label: ele.cname,
          children: cities["RECORDS"]
            .filter((item) => item.state_id == ele.id)
            .map((target) => {
              return { value: target.cname, label: target.cname };
            }),
        });
      });
      this.cityOptions = tempOptionsData;
    },
    handleCityChange(val) {
      if (val && val.length > 0) {
        this.merchantsForm.province = val[0];
        this.merchantsForm.city = val[1];
      } else {
        this.merchantsForm.province = "";
        this.merchantsForm.city = "";
      }
    },
    // onTypeChange(val) {
    //   if (val) {
    //     // 非经销商类型下要清空经营品牌的内容
    //     if (val !== 1) {
    //       this.merchantsForm.brandId = null;
    //       this.merchantsForm.brandName = "";
    //     }
    //     // 私宅业主类型下需要清空公司名称
    //     if (val === 7) {
    //       this.merchantsForm.companyName = "";
    //     }
    //     // 非项目合作的类型需要把公司类型设置为空
    //     if (val !== 3) {
    //       this.merchantsForm.companyTypeId = null;
    //     }
    //   }
    // },
    validateForm() {
      let isPass = true;
      if (isEmprty(this.merchantsForm.typeId)) {
        this.$message.error("请选择类型");
        return false;
      }
      if (isEmprty(this.merchantsForm.name)) {
        this.$message.error("请填写名字");
        return false;
      }
      if (isEmprty(this.merchantsForm.telephoneNo)) {
        this.$message.error("请填写电话号码");
        return false;
      }
      if (!isPhone(this.merchantsForm.telephoneNo)) {
        this.$message.error("请填写正确的手机号码");
        return false;
      }
      if (this.isPhoneRepeat) {
        this.$message.error("该手机号码已存在");
        return false;
      }
      if (
        isEmprty(this.merchantsForm.province) ||
        isEmprty(this.merchantsForm.city)
      ) {
        this.$message.error("请选择您所在的城市");
        return false;
      }
      if (this.isSelfDevelop) {
        if (isEmprty(this.merchantsForm.brandId)) {
          this.$message.error("请选择目前经营品牌");
          return false;
        }
      }

      // 除了私宅业主类型外都要验证公司名称
      // if (this.merchantsForm.typeId !== 7) {
      //   if (isEmprty(this.merchantsForm.companyName)) {
      //     this.$message.error("请填写公司名称");
      //     return false;
      //   }
      // }

      // 项目合作下需要验证公司类型
      // if (this.merchantsForm.typeId === 3) {
      //   if (isEmprty(this.merchantsForm.companyTypeId)) {
      //     this.$message.error("请选择公司类型");
      //     return false;
      //   }
      // }
      return true;
    },
    formatParams() {
      let keys = [
        "sourceId",
        "typeId",
        "promotionCompanyId",
        "companyTypeId",
        "followUpStatusId",
        "ownerId",
        "stageId",
        "brandId",
      ];
      for (const key in this.merchantsForm) {
        if (keys.includes(key)) {
          if (isEmprty(this.merchantsForm[key])) {
            this.merchantsForm[key] = null;
          }
        }
      }
      this.merchantsForm.selfDevelop = this.isSelfDevelop
      return this.merchantsForm
    },
    onSubmit(formName) {
      if (!this.validateForm()) {
        return false;
      }
      this.isSubmiting = true
      this.$api
        .post(`/merchants`, this.formatParams())
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.isSubmiting = false
            this.ininFrom();
            this.$emit("onSuccess");
            this.$message.success("新增成功");
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
          this.$notify.error({
            title: "新增失败",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    ininFrom() {
      this.cityValue = [];
      this.merchantsForm = {
        brandName: "",
        city: "",
        companyName: "",
        country: "中国",
        name: "",
        province: "",
        sourceId: 3,
        telephoneNo: "",
        typeId: 10,
        promotionCompanyId: 1,
        companyTypeId: null,
        followUpStatusId: null,
        ownerId: null,
        stageId: null,
        brandId: null,
        selfDevelop: this.isSelfDevelop,
      };
    },
    async onPhoneBlur(e) {
      try {
        let result = await this.checkPhoneNumberRepeat(e.target.value);
        if (result) {
          this.isPhoneRepeat = true;
        } else {
          this.isPhoneRepeat = false;
        }
      } catch (error) {
        console.log("电话查重异常");
      }
    },
    checkPhoneNumberRepeat(phoneNumber) {
      return new Promise((resolve, reject) => {
        this.$api
          .get(`/merchants/telephone_no/existence?telephoneNo=${phoneNumber}`)
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.merchants-form-compontents {
  /deep/ {
    .el-input__inner {
      border: none;
      outline: none;
      height: 45px;
      line-height: 45px;
    }
  }
}
</style>